import api from "../index";

export const GetSocialTradingUrlApi = (data) => api.post('SocialTrading/get', data);
